import { render, staticRenderFns } from "./Atualizacao.vue?vue&type=template&id=1e514bc9"
import script from "./Atualizacao.vue?vue&type=script&lang=js"
export * from "./Atualizacao.vue?vue&type=script&lang=js"
import style0 from "./Atualizacao.vue?vue&type=style&index=0&id=1e514bc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports